import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, DSIcon } from '@spotahome/ui-library/base';
import { Tooltip } from '@spotahome/ui-library';

import { trans } from '@spotahome/soyuz/client';
import { RnaIdFeatureShape } from '@spotahome/ui-library/src/tenant/constants/shapes';

import './RnaId.scss';

const RnaId = ({ rnaIdFeature = null, className = '' }) => {
  if (!rnaIdFeature || ['no', 'dontKnow'].includes(rnaIdFeature?.value)) {
    return null;
  }

  return (
    <div className={classNames('rna-id', className)}>
      <Typography.ParagraphSShort>
        {trans('listing.rna-id-section.title')}
        <Tooltip
          textClassName="rna-id__tooltip-text"
          color="tertiary"
          tooltip={trans('listing.rna-id-section.tooltip')}
          trigger={['click', 'hover']}
        >
          <DSIcon name="help_circle" />
        </Tooltip>
        {': '}
        {rnaIdFeature.additionalInfo}
      </Typography.ParagraphSShort>
    </div>
  );
};

RnaId.propTypes = {
  rnaIdFeature: PropTypes.shape(RnaIdFeatureShape),
  className: PropTypes.string
};

export default RnaId;
